import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import light from './vuetify/theme'

Vuetify.config.silent = false;
Vue.use(Vuetify);

// Translation provided by Vuetify (javascript)
import de from 'vuetify/es5/locale/de';
import en from 'vuetify/es5/locale/en';
import es from 'vuetify/es5/locale/es';

let user = JSON.parse(localStorage.getItem('currentUser'));


// https://lobotuerto.com/vuetify-color-theme-builder/
const options = {

    lang: {
        locales: { de, en, es },
        current: user?.language.shortcode || 'en'
    },

    icons: {
        iconfont: 'mdi'
    },

    theme: {
        themes: {
            light,
        }
    }
}


export default new Vuetify(options)
